import { render } from "./ProposalTemplateUpdate.vue?vue&type=template&id=57f511c3&scoped=true"
import script from "./ProposalTemplateUpdate.vue?vue&type=script&lang=js"
export * from "./ProposalTemplateUpdate.vue?vue&type=script&lang=js"

import "./ProposalTemplateUpdate.vue?vue&type=style&index=0&id=57f511c3&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f511c3"]])

export default __exports__